import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  RELATORIO_JOB_STATUS,
  isRelatorioJobInFlight,
} from '../../../helpers/relatorioJob';

const RelatorioJobStatusIcon = ({ status }) => {
  if (isRelatorioJobInFlight(status)) {
    return (
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(249,115,22,0.16)',
          color: 'primary.main',
          flexShrink: 0,
        }}
      >
        <CircularProgress size={16} color="inherit" />
      </Box>
    );
  }
  if (status === RELATORIO_JOB_STATUS.ERROR) {
    return (
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'error.light',
          color: 'error.dark',
          flexShrink: 0,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 18 }} />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        width: 34,
        height: 34,
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'success.light',
        color: 'success.dark',
        flexShrink: 0,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
    </Box>
  );
};

RelatorioJobStatusIcon.propTypes = {
  status: PropTypes.string,
};

RelatorioJobStatusIcon.defaultProps = {
  status: null,
};

export default RelatorioJobStatusIcon;
